<template>
  <div class="interview">
    <el-dialog title="发起面试" :visible.sync="interviewVisible" width="500px" :close-on-click-modal="false" center>
      <el-form label-width="120px" :model="interviewAddForm" ref="interviewAddForm" :rules="rules">
        <!--                <el-form-item label="面试名称" prop="interviewName">
                    <el-input v-model="interviewAddForm.interviewName" placeholder="请输入面试名称" clearable></el-input>
                </el-form-item>-->
        <el-form-item label="面试时间" prop="date">
          <el-date-picker v-model="interviewAddForm.date" type="datetime" format="yyyy-MM-dd HH:mm"
            date-format="yyyy-MM-dd" time-format="HH:mm" placeholder="选择面试时间"
            @change="handleDateChange"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="面试时间" prop="time">
          <div class="block">
            <el-time-picker
              placeholder="请选择时间"
              v-model="interviewAddForm.time"
              format="HH:mm"
              value-format="HH:mm"
            ></el-time-picker>
          </div>
        </el-form-item> -->
        <!--                <el-form-item label="面试地址(省市区)" prop="area">
              <el-cascader style="width:100%" :options="areaList" v-model="interviewAddForm.area" ref="cascader" @change="handleAreaChange" clearable></el-cascader>
            </el-form-item>-->
        <el-form-item label="驿站" prop="postStationId">
          <el-select v-model="interviewAddForm.postStationId" clearable placeholder="请选择驿站" filterable
            @change="postStationChange">
            <el-option v-for="(item, index) in postStationList" :key="index" :label="item.postStation"
              :value="item.postStationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务站" prop="stationId">
          <el-select v-model="interviewAddForm.stationId" clearable placeholder="请选择服务站" filterable>
            <el-option v-for="(item, index) in stationList" :key="index" :label="item.station" :value="item.stationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面试详细地址" prop="detailAddress">
          <el-input v-model="interviewAddForm.detailAddress" placeholder="请输入面试详细地址"></el-input>
        </el-form-item>
        <el-form-item label="面试官" prop="interviewerId">
          <el-select v-model="interviewAddForm.interviewerId" clearable placeholder="请选择面试官" filterable>
            <el-option v-for="(item, index) in interviewerList" :key="index" :label="item.userName"
              :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面试内容" prop="interviewContent">
          <el-input type="textarea" v-model="interviewAddForm.interviewContent" :rows="5" placeholder="请输入面试内容"
            class="input-width"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="interviewVisible = false">关闭</el-button>
        <el-button type="primary" @click="saveCreate">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { regionData, regionDataPlus } from "element-china-area-data";
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import taskApi from "@/script/api/taskApi";
import service from "@/script/api/workercrmapi";
import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import {
  validatePhoneTwo,
  validateIdNo,
  validateIdNotmust,
  validateIdNoOrNull,
  validateNumber
} from "@/script/validator";
import router from "@/router";

let vm;
export default {
  data() {
    return {
      clueInfo: {},
      interviewAddForm: {
        interviewName: "",
        date: "",
        //  time:[],
        submitTime: "",
        area: "",
        detailAddress: "",
        interviewerId: "",
        interviewContent: "",
        stationId: "",
        postStationId: ""
      },
      interviewerList: [],
      areaList: regionData,
      interviewVisible: false,
      postStationList: [],
      stationList: [],
      allPostionList: [],
      allStationList: [],
      cityList: [],

      rules: {
        date: [
          {
            required: true,
            message: "请选择面试时间",
            trigger: "change"
          }
        ],
        //  time:[
        //     {
        //         required: true,
        //         message: "请选择面试时间",
        //         trigger: "change",
        //     },
        // ],
        postStationId: [
          {
            required: true,
            message: "请选择驿站",
            trigger: ["blur", "change"]
          }
        ],
        stationId: [
          {
            required: true,
            message: "请选择服务站",
            trigger: ["blur", "change"]
          }
        ],
        interviewerId: [
          {
            required: true,
            message: "请选择面试官",
            trigger: "change"
          }
        ]
      }
    };
  },
  beforeCreate() {
    vm = this;
  },
  methods: {
    handleDateChange(value) {
      console.log(value);
      //将时间格式化成 yyyy-MM-dd HH:mm - HH:mm
      this.interviewAddForm.submitTime = moment(value).format("yyyy-MM-DD HH:mm");
      // 后面的HH:mm 加3小时
      let endTime = moment(value).add(3, "hours").format("HH:mm");
      this.interviewAddForm.submitTime = this.interviewAddForm.submitTime + " - " + endTime;
      console.log(this.interviewAddForm.submitTime);
    },
    init(row) {
      this.clueInfo = row;
      this.getAllInterviewer();
      this.interviewVisible = true;
      this.interviewAddForm = {
        interviewName: "",
        date: new Date(),
        submitTime: "",
        area: "",
        detailAddress: "",
        interviewerId: "",
        interviewContent: "",
        stationId: "",
        postStationId: ""
      };
      // 重置表单校验
      this.$nextTick(() => {
        this.$refs["interviewAddForm"].clearValidate();
      });
      this.queryAllPostStation();
    },
    getAllInterviewer() {
      taskApi
        .$axiosSelectByTypeCityStore({
          campaignId: 2,
          cityId: this.clueInfo.cityId
        })
        .then(res => {
          if (res.data.errno == 0) {
            this.interviewerList = res.data.data;
          }
        });
    },
    handleAreaChange(value) {
      console.log(value);
      console.log(this.interviewAddForm.area == "");
      let node = this.$refs["cascader"].getCheckedNodes();
      console.log(node);
      if (node.length > 0) {
        console.log(node[0].path, node[0].pathLabels);
        this.interviewAddForm.areaCode = node[0].path[2];
        this.interviewAddForm.province = node[0].pathLabels[0];
        this.interviewAddForm.city = node[0].pathLabels[1];
        this.interviewAddForm.county = node[0].pathLabels[2];
        if (
          node[0].pathLabels[2] == "市辖区" &&
          node[0].pathLabels[0] != "北京市" &&
          node[0].pathLabels[0] != "上海市" &&
          node[0].pathLabels[0] != "重庆市" &&
          node[0].pathLabels[0] != "天津市"
        ) {
          this.$notify.error({
            title: "请选择具体区域"
          });
          this.interviewAddForm.area = "";
          return false;
        }
      }
    },

    saveCreate() {
      console.info(this.interviewAddForm);
      this.$refs["interviewAddForm"].validate(valid => {
        if (valid) {
          let obj = this.interviewerList.filter(item => {
            return item.userId == this.interviewAddForm.interviewerId;
          });

          if (!this.interviewAddForm.submitTime) {
            //将时间格式化成 yyyy-MM-dd HH:mm - HH:mm
            this.interviewAddForm.submitTime = moment(new Date()).format("yyyy-MM-DD HH:mm");
            // 后面的HH:mm 加3小时
            let endTime = moment(new Date()).add(3, "hours").format("HH:mm");
            this.interviewAddForm.submitTime = this.interviewAddForm.submitTime + " - " + endTime;
            console.log(this.interviewAddForm.submitTime);
          }

          let params = {
            interviewName: this.interviewAddForm.interviewName,
            interviewContent: this.interviewAddForm.interviewContent,
            relationClueId: this.clueInfo.id,
            interviewTime: this.interviewAddForm.submitTime,
            //address:this.interviewAddForm.province+this.interviewAddForm.city+this.interviewAddForm.county+this.interviewAddForm.county+this.interviewAddForm.detailAddress,
            address: this.interviewAddForm.detailAddress,
            interviewerId: obj[0].userId,
            interviewerName: obj[0].userName,
            interviewerTitle: obj[0].sysUser.position,
            postStationId: this.interviewAddForm.postStationId,
            stationId: this.interviewAddForm.stationId
          };
          taskApi.$axiosStartInterview(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("操作成功");
              this.interviewVisible = false;

              this.$router.push('/workermanager/empowermentTrain/interviewList');

              this.$parent.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        }
      });
    },
    queryAllPostStation() {
      service.$axiosGetAllPostStation().then(res => {
        console.log(res.data.data);
        this.cityList = res.data.data.city;
        this.allPostionList = res.data.data.postStation;
        this.allStationList = res.data.data.station;
        this.postStationList = this.allPostionList.slice();
        this.stationList = this.allStationList.slice();
      });
    },
    postStationChange() {
      this.interviewAddForm.stationId = "";
      if (
        this.interviewAddForm.postStationId != null &&
        this.interviewAddForm.postStationId !== ""
      ) {
        this.stationList = [];
        let postStationId = this.interviewAddForm.postStationId;
        this.allStationList.filter(a => {
          if (a.postStationId == postStationId) {
            this.stationList.push(a);
          }
        });
      } else {
        this.stationList = this.allStationList.slice();
      }
    }
  }
};
</script>
<style scoped>
.interview {
  :deep(.el-dialog__body) {
    padding: 25px 20px !important;
  }

  :deep(.el-form) {
    .el-form-item {
      margin-bottom: 18px;
    }
  }

  :deep(.el-form-item__content) {
    display: flex;
  }

  :deep(.el-date-editor.el-input),
  :deep(.el-date-editor),
  :deep(.el-select),
  :deep(.el-input),
  :deep(.el-textarea) {
    flex: 1;
  }
}
</style>
